import { useEffect, useState } from 'react'
import { useNetworkStatus } from '@/api'
import type { ProcessState } from '@/features/process/projection'
import { loadHall } from './hallApi'

/**
 * Reads the hall's runs and lots (and buyers when `buyers`, for the hall keeper's dispatch)
 * whenever a fresh site list arrives (it carries none) and the phone is online. `refresh` reads
 * them again on a tap.
 */
export function useHall(state: ProcessState, opts: { buyers?: boolean } = {}) {
  const buyers = opts.buyers ?? false
  const { online } = useNetworkStatus()
  const [busy, setBusy] = useState(false)
  const siteId = state.siteId
  const at = state.downloadedAt
  // A started pack run in the site list's open runs that the hall lists do not have yet.
  const missing = [...state.runs.values()]
    .filter((r) => r.step_code === 'PACK' && !state.packRuns.has(r.id))
    .map((r) => r.id)
    .join(',')
  useEffect(() => {
    if (!online) return
    void loadHall(siteId, { buyers }).catch(() => undefined)
  }, [online, siteId, at, missing, buyers])
  const refresh = () => {
    setBusy(true)
    void loadHall(siteId, { buyers })
      .catch(() => undefined)
      .finally(() => setBusy(false))
  }
  return { online, busy, refresh }
}
